var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.processing),expression:"processing"}],staticClass:"checkout-processing",style:(_vm.getOpacity)},[_c('h2',{staticStyle:{"font-weight":"bold","padding-bottom":"1rem"}},[_vm._v("Processing...")]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fa fa-refresh fa-5x spinner"})])
}]

export { render, staticRenderFns }